import { FROM_MESSAGES, ListenerCallbacks, PlayerCache, TO_MESSAGES } from './types';

const playerCache: PlayerCache = {
  iframe: null,
  callbacks: {
    load: () => {},
    unload: () => {},
  },
  loadListener: () => {},
  unloadListener: () => {},
  playerMessageListener: () => {},
};

const sendMessageToPlayer = (message: string, payload: unknown) => {
  const iframe = playerCache.iframe;
  if (!iframe) return;

  iframe.contentWindow?.postMessage(
    {
      type: message,
      payload,
    },
    '*'
  );
};

const connectPlayer = (iframe: HTMLIFrameElement, listenerCallbacks: ListenerCallbacks) => {
  playerCache.callbacks = listenerCallbacks;

  const loadListener = () => {
    const onPlayerMessage = (event: MessageEvent) => {
      switch (event.data.type) {
        case FROM_MESSAGES.DARK_MODE_UPDATED:
          playerCache.callbacks[FROM_MESSAGES.DARK_MODE_UPDATED]?.(event);
          break;
        default:
          break;
      }
    };

    playerCache.playerMessageListener = onPlayerMessage;
    window.addEventListener('message', onPlayerMessage);
  };

  const unloadListener = () => {
    playerCache.callbacks.unload();
  };

  playerCache.iframe = iframe;
  playerCache.loadListener = loadListener;
  playerCache.unloadListener = unloadListener;

  iframe.addEventListener('load', playerCache.loadListener);
  iframe.addEventListener('unload', playerCache.unloadListener);
};

const disconnectPlayer = (iframe: HTMLIFrameElement) => {
  iframe.removeEventListener('load', playerCache.loadListener);
  iframe.removeEventListener('unload', playerCache.unloadListener);
  window.removeEventListener('message', playerCache.playerMessageListener);

  playerCache.iframe = null;
  playerCache.loadListener = () => {};
  playerCache.unloadListener = () => {};
  playerCache.playerMessageListener = () => {};
};

const toggleDarkMode = (isDarkMode: boolean) => {
  sendMessageToPlayer(TO_MESSAGES.TOGGLE_DARK_MODE, {
    isDarkMode,
  });
};

export default {
  connect: connectPlayer,
  disconnect: disconnectPlayer,
  toggleDarkMode,
};
